<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true" :destroy-on-close="true"
    custom-class="max-dialog">
    <div style="width: 100%">
      <el-radio v-model="saleserial" :key="item.erpserial" :label="item.erpserial" border v-for="(item,index) in order" @change="showItems">
        {{item.erpserial}} （{{item.handleoverdate}} &nbsp;{{item.logisticsco}}{{item.logisticsnum}}）
      </el-radio>
    </div>
    <el-table
      :data="tabledata"
      :height="tableHeight(131)"
      size="mini"
      stripe
      border

      style="width: 100%;">
      <el-table-column
        type="index"
        width="60"
        label="序号"
        align="center">
      </el-table-column>
      <el-table-column
        prop="seedcode"
        label="商品编码" width="150px"
        align="center"
        header-align="center">
      </el-table-column>
      <el-table-column
        prop="seedname"
        label="商品名称"
        align="left"
        header-align="center" >
      </el-table-column>
      <el-table-column
        prop="type"
        label="R/L" width="90px"
        align="left"
        header-align="center">
      </el-table-column>
      <el-table-column
        prop="Y"
        label="球镜" width="90px"
        align="left"
        header-align="center">
      </el-table-column>
      <el-table-column
        prop="X"
        label="柱镜" width="90px"
        align="left"
        header-align="center">
      </el-table-column>
      <el-table-column
        prop="number"
        label="采购数量" width="90px"
        align="left"
        header-align="center">
        <template slot-scope="scope">
          <span style="color: red" v-if="scope.row.number>scope.row.buynumber">{{scope.row.number}}</span>
          <span v-else>{{scope.row.number}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="buynumber"
        label="发货数量" width="90px"
        align="left"
        header-align="center">
        <template slot-scope="scope">
          {{ scope.row.buynumber==0?'':scope.row.buynumber }}
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close" size="medium">取 消</el-button>
      <el-button type="primary" @click="update" :loading="loading" size="medium">确认入库</el-button>
    </div>
  </el-dialog>
</template>

<script>
    import {getBySerial} from '@/api/set/externaldept';
    import {listSimple,updateFastbuyorder} from '@/api/set/csagreement';
    import {login, listOrder,backOrder,detailOrder} from '@/api/ossi';

    export default {
      name: "BuyfromFastCheck",
      data() {
        return {
          title: '订单信息',
          loading:false,
          showlookprice:true,
          dialogSeeVisible: false,
          ssotoken: '',
          website: '',
          erpserial: '',
          pcustomerserial: '',
          userInfoModel: [],
          order: [],
          saleserial:'',
          buyitems:{},
          tabledata:[],
          existotherorder:false,
        }
      },
      methods: {
        close() {
          this.dialogSeeVisible = false;
        }
        ,
        lookDetails(item) {
        },
        backOrder(item) {
          if (item.status == 100) {
            this.$confirm('是否确定取消订单?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {

              backOrder({erpserial: item.erpserial}, this.ssotoken).then(resDel => {
                this.afterLogin();
              });

            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });
          }
        },
        show(erpserial, pcustomerserial, buyitems) {
          this.saleserial='';
          this.loading=false;
          this.buyitems = buyitems[0];
          console.log(this.buyitems)
          if (erpserial && erpserial.length >= 14 && erpserial.substr(0, 2) == 42) {
            this.erpserial = erpserial;
            this.pcustomerserial = pcustomerserial;
            getBySerial({customerserial: this.pcustomerserial}).then(resCus => {
              if (resCus.data.code == 0 && resCus.data.obj.usesso == '1' && resCus.data.obj.ssocode) {
                this.dialogSeeVisible = true;
                login({idencode: resCus.data.obj.ssocode, tenantid: this.userInfoModel.tenantid}).then(loginres => {
                  if (loginres.data.code == 0) {
                    this.ssotoken = loginres.data.msg;
                    this.website = loginres.data.website;
                    this.afterLogin();
                  } else {
                    this.$message({message: loginres.data.msg, type: 'error'})
                  }
                });
              }
            });
          }
        },
        afterLogin() {
          this.existotherorder = false;
          this.order = [];
          listOrder({erpserial: this.erpserial}, this.ssotoken).then(resOrder => {//供应商订单信息
            if (resOrder.data.code == 0) {
              listSimple({notfilterindependent: "1", groupguid: this.buyitems.groupguid}).then(resBuy => {//所有采购单列表
                var fahuo = ';';
                for (let i in resBuy.data.obj) {
                  if (resBuy.data.obj[i].status == 820) {//同一批次 已收货的订单排除
                    fahuo += resBuy.data.obj[i].tracknum + ';';
                  }
                }

                for (let i in resOrder.data.obj.rows) {
                  var r = resOrder.data.obj.rows[i];
                  if ((r.status == 400 || r.status == 500) && fahuo.indexOf(';' + r.erpserial + ';') == -1) {//供应商已发货订单
                    if (this.saleserial == '')
                      this.saleserial = r.erpserial;
                    this.order.push(r);
                  } else {
                    if ((r.status == 200 || r.status == 350) && r.isreturnorder != -1)//存在未发货的订单
                      this.existotherorder = true;
                  }
                }
                if (this.order.length > 1) {//发了多次 都没签收的
                  this.existotherorder = true;
                }
                if (this.order.length == 0) {
                  this.$message({message: '供应商尚未发货！', type: 'error'})
                  this.dialogSeeVisible = false;
                } else {
                  this.showItems();
                }
              });
            }
          });
        },
        showItems() {
          this.tabledata=[];
          detailOrder({erpserial: this.saleserial}, this.ssotoken).then(resOrder => {//供应商订单信息
            if (resOrder.data.code == 0) {
              var subNumber=0;
              var subBuynumber=0;

              for (let i in this.buyitems.billmap) {
                var buyGoods = this.buyitems.billmap[i];
                var row = {seedcode: "", seedname: "", X: "", Y: "", type: "", number: 0, buynumber: 0};
                for (let j in buyGoods) {
                  for (var key in buyGoods[j]) {
                    switch (key) {
                      case "seedcode":
                        row.seedcode = buyGoods[j][key];
                        break;
                      case "产品名称":
                        row.seedname = buyGoods[j][key];
                        break;
                      case "球镜":
                        row.Y = buyGoods[j][key];
                        break;
                      case "柱镜":
                        row.X = buyGoods[j][key];
                        break;
                      case "R/L":
                        row.type = buyGoods[j][key];
                        break;
                      case "数量":
                        if (row.seedname != '合计') {
                          row.number = parseInt(buyGoods[j][key]);
                          subNumber += row.number;
                        }
                        break;
                    }
                  }
                }
                if (row.seedname == '合计') {
                  row.number = subNumber;
                  row.buynumber = subBuynumber;
                }  else {
                  //拼接实际发货数量
                  for (let j in resOrder.data.obj.goodsDetail) {
                    var sendGoods = resOrder.data.obj.goodsDetail[j];
                    if (sendGoods.seedcode == row.seedcode &&
                      (sendGoods["球镜"] || '') == row.Y &&
                      (sendGoods["柱镜"] || '') == row.X &&
                      (sendGoods["R/L"] || '') == row.type) {
                      row.buynumber = parseInt(sendGoods["数量"]);
                      subBuynumber += row.buynumber;
                      break;
                    }
                  }
                }
                this.tabledata.push(row);
              }
            } else {
              this.$message({message: resOrder.data.msg, type: 'error'})
            }
          });
        },
        update() {
          this.loading = true;
          updateFastbuyorder({
            unitguid: this.buyitems.unitguid,
            tracknum:this.saleserial,
            otherorder: this.existotherorder ? 1 : 0,
            details: JSON.stringify(this.tabledata)
          }).then(resOrder => {
            if (resOrder.data.code == 0) {
              this.$emit('afterCheckIn');
              this.dialogSeeVisible = false;
            } else {
              this.$message({message: resOrder.data.msg, type: 'error'})
              this.loading = false;
            }
          });
        },
        getSummaries(param) {
          var number = 0, buynumber = 0
          const {columns, data} = param;
          data.forEach((column, index) => {

            number += column.number
            buynumber += column.buynumber

          });
          const sums = [];
          columns.forEach((column, index) => {
            if (index === 0) {
              sums[index] = '合计';
              return;
            }
            switch (column.label) {
              case '采购数量':
                sums.push(number)
                break;
              case '发货数量':
                sums.push(buynumber)
                break;
            }

          });
          return sums;
        },
      },
      mounted() {
        this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      },
      components:{

      }
    }
</script>



// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyfromFastCheck.vue